import React from 'react';

const brands = [
  { name: 'Viator', src: '/img/logo/viator.webp' },
  { name: 'Bitget', src: '/img/logo/bitget.webp' },
  { name: 'Hitachi', src: '/img/logo/hitachi.webp' },
  { name: '1xBet', src: '/img/logo/1xbet.webp' },
  { name: 'VT Markets', src: '/img/logo/vt-markets.webp' },
  { name: 'MuscleBlaze', src: '/img/logo/muscleblaze.png' },
  { name: 'Udemy', src: '/img/logo/udemy.png' },
  { name: 'Surfshark', src: '/img/logo/surfshark.webp' },
  { name: 'Betsson', src: '/img/logo/betsson.webp' },
  { name: 'Grab', src: '/img/logo/grab.png' },
  { name: 'IQ Option', src: '/img/logo/iq%20option.webp' },
];

export default function LogoStrip() {
  const doubled = [...brands, ...brands];
  return (
    <section className="border-y border-[#1a1a1a] py-8 md-py-12 lg:py-16 overflow-hidden bg-[#1a1a1a] relative" data-testid="logo-strip">
      <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360">
        <h2 className="reveal-on-scroll section-heading text-center">Proven across <span className='text-green'>12+ Verticals </span> Globally</h2>
      </div>
      <div className="overflow-hidden hide-scrollbar mt-4 lg;:mt-8 ">
        <div className="marquee">
          {doubled.map((b, i) => (
            <div
              key={i}
              className="logo-marquee-item"
              aria-label={b.name}
            >
              <img src={`${process.env.PUBLIC_URL}${b.src}`} alt={`${b.name} logo`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
